<template>
  <div class="modal-dialog" v-if="showDialog">
    <h1>{{ title }}</h1>
    <p>{{ desc }}</p>
    <button @click="confirm">{{ confirmText }}</button>
    <button @click="cancel">{{ cancelText }}</button>
  </div>
</template>

<script>
export default {
  name: 'modal-dialog',

  mounted () {
    let that = this
    this.$bus.on('showDialog', function (data) {
      that.title = data.title
      that.desc = data.desc
      if (typeof data.confirmAction !== 'undefined') that.confirmAction = data.confirmAction
      if (typeof data.cancelAction !== 'undefined') that.cancelAction = data.cancelAction
      that.showDialog = true
    })
  },

  methods: {
    confirm () {
      if (this.confirmAction.length) this.$bus.emit(this.confirmAction)
      this.showDialog = false
    },

    cancel () {
      if (this.cancelAction.length) this.$bus.emit(this.cancelAction)
      this.showDialog = false
    }
  },

  data () {
    return {
      title: 'Modal Title',
      desc: 'The description of the modal',
      confirmAction: '',
      cancelAction: '',
      confirmText: 'Confirm',
      cancelText: 'Cancel',
      showDialog: false
    }
  },

  beforeDestroy () {
    this.$bus.$off('showDialog')
  }
}
</script>

<style lang="scss" scoped>
  .modal-dialog {
    margin: auto;
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background-color: white;
    border: 2px solid black;
    border-radius: 8px;
    height: 200px;
    padding: 10px;
    user-select: none;
    z-index: 99999999999999;
    pointer-events: auto;

    h1 {
      text-align: center;
    }

    button {
      background-color: #2d5f8b;
      color: white;
      border: none;
      box-shadow: 2px 2px 2px #555;
      min-width: 100px;
      min-height: 35px;
      float: right;
      margin-left: 25px;

      &:hover {
        background-color: #2C7FFF;
        box-shadow: 2px 2px 2px #333;
      }

      &:active {
        box-shadow: 1px 1px 1px #333;
      }

      &:focus {
        outline: none;
      }
    }
  }
</style>





// WEBPACK FOOTER //
// src/components/editor/modals/ModalDialog.vue